module.exports = __webpack_public_path__ + "assets/images/purple-close-icon.4a60a4b38d70b4ad8632c8e088e59e0b.svg";